// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__Puunv","title":"AfterImages90_title__39vwp","images":"AfterImages90_images__1eJqe"};